// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: io/reload_plugin_input.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

/** [Internal] Input to a reload plugin request to Hank. */
export interface ReloadPluginInput {
  /** The plugin to reload. */
  plugin: string;
}

function createBaseReloadPluginInput(): ReloadPluginInput {
  return { plugin: "" };
}

export const ReloadPluginInput: MessageFns<ReloadPluginInput> = {
  encode(message: ReloadPluginInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.plugin !== "") {
      writer.uint32(10).string(message.plugin);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReloadPluginInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReloadPluginInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.plugin = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReloadPluginInput {
    return { plugin: isSet(object.plugin) ? globalThis.String(object.plugin) : "" };
  },

  toJSON(message: ReloadPluginInput): unknown {
    const obj: any = {};
    if (message.plugin !== "") {
      obj.plugin = message.plugin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReloadPluginInput>, I>>(base?: I): ReloadPluginInput {
    return ReloadPluginInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReloadPluginInput>, I>>(object: I): ReloadPluginInput {
    const message = createBaseReloadPluginInput();
    message.plugin = object.plugin ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
